<div
    class="payment-placeholder"
    aria-hidden="true"
    data-testid="booking-payment-placeholder"
>
    <div class="payment-placeholder-field payment-placeholder-card-number">
        <span class="payment-placeholder-label">Card number</span>
        <span class="payment-placeholder-value">1234 1234 1234 1234</span>
    </div>
    <div class="payment-placeholder-row">
        <div class="payment-placeholder-field">
            <span class="payment-placeholder-label">Expiry date</span>
            <span class="payment-placeholder-value">MM / YY</span>
        </div>
        <div class="payment-placeholder-field">
            <span class="payment-placeholder-label">Security code</span>
            <span class="payment-placeholder-value">CVC</span>
        </div>
    </div>
</div>
